import fetchAPI from "./fetchAPI"

export async function createShare(data, path, token) {
  const { createShare } = await fetchAPI(
    `mutation($data: JSON!, $path: String!, $token: String!, ) {
      createShare(data: $data, path: $path, token: $token) {
        success
        hash
        path
      }
    }`,
    {
      variables: { data, path, token }
    },
    true
  )

  return createShare
}
